import { RSAA } from 'redux-api-middleware';
import config from 'config';

export const updateBulkActionList = (pageSize, page, sorted, filtered, resized, expanded) => {
    return {
  
      [RSAA]: {
        endpoint: `${config.apiRoot}/bulk-action/list`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ pageSize, page, sorted, filtered }),
        types: [
          {
            type: 'UPDATE_BULK_ACTION_LIST_REQUEST',
            payload: { listState: {pageSize, page, sorted, filtered, resized, expanded} }
          },
          'UPDATE_BULK_ACTION_LIST_SUCCESS',
          'UPDATE_BULK_ACTION_LIST_FAILURE'
        ]
      }
    };
  };
  